import React from 'react';
import { PlusIcon } from 'lucide-react';
import { FAQS } from '../../data/content';
export function Faq() {
  return <section className="relative w-full bg-ink px-5 py-12 sm:py-16" data-id="element-91" data-mp="1c1kl7i4zb1t2">
      <div className="mx-auto max-w-2xl" data-id="element-92" data-mp="x41xmj41eun7">
        <h2 className="text-center font-display text-3xl text-white sm:text-5xl" data-id="element-93" data-mp="x5d2km97y8fw">
          ❓ Lo que más nos preguntan
        </h2>

        <div className="mt-7 space-y-2.5" data-id="element-94" data-mp="1ps7jxaaqorp5">
          {FAQS.map((faq, index) => <details key={faq.q} open={index === 0} className="group rounded-xl border border-ink-border bg-ink-card" data-id="element-95" data-mp="1puk0bj0umu03" data-mpi={index}>
              <summary className="flex cursor-pointer list-none items-center justify-between gap-3 p-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-aqua [&::-webkit-details-marker]:hidden" data-id="element-96" data-mp="1g1v0xmikp6l4">
                <span className="text-sm font-bold text-white sm:text-base" data-id="element-97" data-mp="2dhs5m0ya2324">{faq.q}</span>
                <PlusIcon className="h-4 w-4 flex-shrink-0 text-lime transition-transform duration-200 group-open:rotate-45" aria-hidden="true" data-id="element-98" data-mp="2djmol9pznl3k" />
              </summary>
              <p className="px-4 pb-4 text-sm leading-relaxed text-white/70" data-id="element-99" data-mp="2ygk02kx456nv">{faq.a}</p>
            </details>)}
        </div>
      </div>
    </section>;
}